import { render } from "./ProjectEntry.vue?vue&type=template&id=0e97fa96"
import script from "./ProjectEntry.vue?vue&type=script&lang=js"
export * from "./ProjectEntry.vue?vue&type=script&lang=js"

import exportComponent from "/Users/william/Documents/beadographer3/bead3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__